module.exports = __webpack_public_path__ + "img/icon-needs-ai.cf9f2da4.svg";